import pimg1 from '../images/project/1.jpg';
import pimg2 from '../images/project/2.jpg';
import pimg3 from '../images/project/3.jpg';
import pimg4 from '../images/project/4.jpg';
import pimg5 from '../images/project/1.jpg';


import p2img1 from '../images/project-single/img-1.jpg'
import p2img2 from '../images/project-single/img-2.jpg'
import p2img3 from '../images/project-single/img-3.jpg'
import p2img4 from '../images/project-single/img-4.jpg'
import p2img5 from '../images/project-single/img-1.jpg'






const Projects = [
    {
        id: '1',
        title: 'Custom Fabrication',
        subtitle: 'Quis sit',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Custom-Fabrication',
        pimg1: pimg1,
        pSimg: p2img1,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '2',
        title: 'Manufacturing Plan',
        subtitle: 'Quis sit',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Manufacturing-Plan',
        pimg1: pimg2,
        pSimg: p2img2,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '3',
        title: 'Mechanical Works',
        subtitle: 'Quis sit',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Mechanical-Works',
        pimg1: pimg3,
        pSimg: p2img3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
 
    {
        id: '4',
        title: 'Chemical Refinery',
        subtitle: 'Quis sit',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Chemical-Refinery',
        pimg1: pimg4,
        pSimg: p2img4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '5',
        title: 'Petroleum Production',
        subtitle: 'Quis sit',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg5,
        pSimg: p2img5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    }
 



]
export default Projects;






